import { Box } from "@mui/material"

export const Top = (props) => {
    const {loc} = props

    return (
        <Box minHeight="80px" bgcolor="#ECECEC" borderRadius="10px" display="flex" alignItems="center" justifyContent="space-between" px={3}>
            <Box component="strong" fontSize={16}>{loc === 'create' ? 'Add' : 'Update' } Company Cutoff</Box>
        </Box>
    )
}